"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogRoute = exports.buildDialogQueryFn = void 0;
var React = require("react");
var queryString = require("query-string");
var query_route_1 = require("./query-route");
// This function allows us to find dialogs in a comma-separate series
// eg, foo.com/bar?pwaDialog=dialogA,dialogB,dialogC
var buildDialogQueryFn = function (dialogId) {
    return function (query) {
        return query.split(',').includes(dialogId);
    };
};
exports.buildDialogQueryFn = buildDialogQueryFn;
var DialogRoute = /** @class */ (function (_super) {
    __extends(DialogRoute, _super);
    function DialogRoute() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogRoute.buildDialogChain = function (query, dialogId, key) {
        if (key === void 0) { key = 'pwaDialog'; }
        var queryObj = queryString.parse(query);
        return queryObj[key] ? "".concat(queryObj[key], ",").concat(dialogId) : dialogId;
    };
    DialogRoute.appendDialogToQuery = function (query, dialogId, key) {
        var _a;
        if (key === void 0) { key = 'pwaDialog'; }
        var queryObj = queryString.parse(query);
        var dialogChain = queryObj[key] ? "".concat(queryObj[key], ",").concat(dialogId) : dialogId;
        var enhancedQuery = __assign(__assign({}, queryObj), (_a = {}, _a[key] = dialogChain, _a));
        return queryString.stringify(enhancedQuery);
    };
    DialogRoute.prototype.render = function () {
        var _a;
        var _b = this.props, children = _b.children, id = _b.id, type = _b.type, useQueryBuilder = _b.useQueryBuilder;
        var query = useQueryBuilder ? (0, exports.buildDialogQueryFn)(id) : id;
        var queryVal = (_a = {}, _a[type] = query, _a);
        return React.createElement(query_route_1.QueryRoute, { query: queryVal }, children);
    };
    DialogRoute.defaultProps = {
        type: 'pwaDialog',
        useQueryBuilder: true,
    };
    return DialogRoute;
}(React.Component));
exports.DialogRoute = DialogRoute;
//# sourceMappingURL=dialog-route.js.map